// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ck-6";
export var emphasizeQuantity = "_ck-3";
export var flatBottomCorners = "_ck-5";
export var productImage = "_ck-0";
export var quantityContainer = "_ck-2";
export var tooltip = "_ck-1";
export var wrapAndEllipsesOverflow = "_ck-4";